/* eslint-disable @typescript-eslint/no-redeclare */
import { z } from 'zod';
import { ICustomProjectField } from '~/types/model.types';
import { ICustomFieldSchema } from '~/components/CustomFields/custom-field-schemas.types';
import { WorkflowAutomationType } from '~/types/enums.types';
import { DEFAULT_FILE_EXPIRATION_TIME_OPTIONS } from '~/apps/main/CompanySettings/CompanyPreferences/company-preferences.constants';

export const TCompanySpace = z.object({
    _id: z.string(),
    name: z.string()
});

export type TCompanySpace = z.infer<typeof TCompanySpace>;

export type TCompanySpaceUpdate = Partial<TCompanySpace> &
    Pick<TCompanySpace, 'name'>;

export type TPayoutDelayReason = {
    notification:
        | 'missing_bank_account'
        | 'transfer_disabled'
        | 'fields_needed';
};

export type TProjectField = ICustomProjectField & { editable: boolean };

export type TCustomProjectFieldUpdate = Omit<
    ICustomProjectField,
    '_id' | 'identifier'
> &
    Partial<TProjectField>;

export type TCustomProjectFieldsUpdateResponse = {
    custom_project_fields_v2: ICustomFieldSchema[];
};

export type TCustomContactFieldsUpdateResponse = {
    custom_contact_fields: ICustomFieldSchema[];
};

export type TInquiryFollowUpTimeFrameValue = 1 | 2 | 3 | 4;

export type ReminderAutomationType =
    | 'auto_recurring_payment_reminder'
    | 'due_payment_reminder'
    | 'outstanding_payment_reminder'
    | 'upcoming_payment_reminder'
    | 'longer_outstanding_payment_reminder'
    | 'late_fee_on_outstanding_payments';

export type TDefaultAutoExpirationOption =
    (typeof DEFAULT_FILE_EXPIRATION_TIME_OPTIONS)[number];

export type ActionAutomationType = Extract<
    WorkflowAutomationType,
    | 'client_file_not_viewed'
    | 'automation_send_questionnaire'
    | 'send_flow_before_project'
>;

export type TListSectionRowType =
    | 'lead_sources'
    | 'project_fields'
    | 'project_types'
    | 'spaces'
    | 'contact_fields'
    | 'tags';
